import React from "react";
import { Typography, Box, Fade } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { selectCurrentQuestionObject } from "features/question/questionSlice";

const CategoryText = styled(Typography)({
  fontFamily: "Gyparody",
  fontSize: "2.5em",
  color: "#1700a0",
  textAlign: "center",
  paddingTop: "32px",
});

const SubText = styled(Typography)(({ theme }) => ({
  fontFamily: "Korinna",
  fontSize: "1.2em",
  color: "#666",
  textAlign: "center",
  paddingTop: theme.spacing(2),
}));

const FinalCategoryPreview = () => {
  const question = useSelector(selectCurrentQuestionObject);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
    >
      <Typography variant="h5" sx={{ fontFamily: "Gyparody", color: "#333" }}>
        Final Jeopardy!
      </Typography>
      <Fade in={!!question} timeout={1500}>
        <CategoryText variant="h3">
          {question?.category?.toUpperCase() || ""}
        </CategoryText>
      </Fade>
      <SubText>
        Think about your wager...
      </SubText>
    </Box>
  );
};

export default FinalCategoryPreview;
